import FormButton from "../Components/Buttons/FormButton";
import { useRef } from "react";
import "../assets/css/style.css";
import GetSvgIcon from "../assets/images/svgList";

const ImportLayout = ({ handleClose }: { handleClose: () => void }) => {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleSubmit = () => {
    handleClose();
  };

  const handleDivClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      // console.log("File selected:", file.name);
      // Handle the file upload logic here
    }
  };

  return (
    <>
      <form onSubmit={handleSubmit} className="form">
        <div className="input-div d-flex justify-content-center cursor-pointer import-area rounded py-5" onClick={handleDivClick}>
        <div className="d-flex flex-column text-center">
        <div className=" mb-4">{GetSvgIcon.GlobalUpArrow}</div>
        <h5>Drag and drop the file to import</h5>
        <a href="#" className="text-primary fw-semibold fs-12">Browse file</a>
        <p className="mt-2 mb-0 text-lightgrey-50">5MB max file size</p>
        </div>
          <input
            type="file"
            ref={fileInputRef}
            className="d-none "
            onChange={handleFileChange}
          />
        </div>

        <div className="d-flex justify-content-between mt-3 gap-2 align-items-center">
            <a className="link cursor-pointer fs-14 text-grey">Download Template</a>
          <div className="d-flex gap-2">
          <FormButton
            tabIndex={26}
            className="sph-btn sph-shift"
            handleClick={handleClose}
          >
            Cancel
          </FormButton>
          <FormButton
            tabIndex={25}
            className="sph-btn me-2"
            handleClick={handleClose}
          >
            Submit
          </FormButton>
          </div>
        </div>
      </form>
    </>
  );
};

export default ImportLayout;
